import React from "react";
import {toast} from "react-toastify";
import {Home} from "../Home/Home";

export const LandingPage = () => {

    const show = () => {
        toast.success('done!');
    }

    return (
        <>
            <h1>Hello</h1>
        </>
    )
}
